import { tableSet } from "common/data/table";
import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

function structuralWallTypeNew(
  name: string,
  structuralMaterialId: string,
  exteriorSubstrateMaterialId?: string,
  membraneMaterialId?: string,
  thermalMaterialId?: string,
): any {
  return {
    name,
    structuralMaterialId,
    exteriorSubstrateMaterialId,
    membraneMaterialId,
    thermalMaterialId,
  };
}

function lumberProfileDescriptorNew(type: string, name: string, width: number, height: number): any {
  return {
    type,
    name,
    width,
    height,
  };
}

const LumberProfileCatalog: { [key: string]: any } = {
  ["SPF_2X4"]: lumberProfileDescriptorNew("SPF_2X4", "2x4 SPF", 3.5, 1.5),
  ["SPF_2X6"]: lumberProfileDescriptorNew("SPF_2X6", "2x6 SPF", 5.5, 1.5),
  ["SPF_2X8"]: lumberProfileDescriptorNew("SPF_2X8", "2x8 SPF", 7.25, 1.5),
  ["SPF_2X10"]: lumberProfileDescriptorNew("SPF_2X10", "2x10 SPF", 9.25, 1.5),
  ["SPF_2X12"]: lumberProfileDescriptorNew("SPF_2X12", "2x12 SPF", 11.25, 1.5),
};

const wallMaterialIdFromLumberProfile: { [key: string]: string } = {
  ["SPF_2X4"]: "defaultStructuralMaterial2X4",
  ["SPF_2X6"]: "defaultStructuralMaterial2X6",
  ["SPF_2X8"]: "defaultStructuralMaterial2X8",
  ["SPF_2X10"]: "defaultStructuralMaterial2X10",
  ["SPF_2X12"]: "defaultStructuralMaterial2X12",
};

function wallConditionDataNew(wallTypeId: string): any {
  return {
    wallTypeId,
  };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_76: DocMigration = {
  maxSchemaVersion: "0.0.76",
  description: "wall types",
  apply(json: any) {
    const getLumberProfileFromThickness = (thickness: number): string => {
      for (const profileType in LumberProfileCatalog) {
        if (LumberProfileCatalog[profileType].width >= thickness) {
          return profileType;
        }
      }

      return "SPF_2X8";
    };

    let wallTypes: { readonly [id: string]: any } | undefined = undefined;
    const allSettings = json.settings;

    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "WALL_SETTINGS") {
        continue;
      }

      const { exteriorWallThickness = 3.5, interiorWallThickness = 3.5 } = settings;

      const interiorWallId = uid();
      const exteriorWallId = uid();

      if (!wallTypes) {
        wallTypes = {};
      }

      wallTypes = tableSet(
        wallTypes,
        interiorWallId,
        structuralWallTypeNew(
          "WALL-INT-STD",
          wallMaterialIdFromLumberProfile[getLumberProfileFromThickness(interiorWallThickness)],
        ),
      );
      wallTypes = tableSet(
        wallTypes,
        exteriorWallId,
        structuralWallTypeNew(
          "WALL-EXT-STD",
          wallMaterialIdFromLumberProfile[getLumberProfileFromThickness(exteriorWallThickness)],
        ),
      );

      const wallConditions: { [key: string]: any } = {
        ["EXTERIOR_INTERIOR"]: wallConditionDataNew(exteriorWallId),
        ["EXTERIOR_GARAGE"]: wallConditionDataNew(exteriorWallId),
        ["EXTERIOR_PLUMBING"]: wallConditionDataNew(exteriorWallId),
        ["EXTERIOR_DORMER"]: wallConditionDataNew(exteriorWallId),
        ["EXTERIOR_GABLE_END"]: wallConditionDataNew(exteriorWallId),
        ["INTERIOR_INTERIOR"]: wallConditionDataNew(interiorWallId),
        ["INTERIOR_GARAGE"]: wallConditionDataNew(interiorWallId),
        ["INTERIOR_PLUMBING"]: wallConditionDataNew(interiorWallId),
      };

      settings.wallConditions = wallConditions;
      delete settings.exteriorWallThickness;
      delete settings.interiorWallThickness;
    }

    if (wallTypes) {
      const wallCatalogSettingsId = uid();
      allSettings[wallCatalogSettingsId] = {
        type: "WALL_CATALOG_SETTINGS",
        wallTypes,
      };

      if (!json.settingsOverride) {
        json.settingsOverride = {};
      }

      json.settingsOverride.wallCatalog = wallCatalogSettingsId;
    }
    return json;
  },
};

export default migration_0_0_76;
